<template>
	<div class="row">
		<div class="col-12">
			<div class="row">
				<div class="col-12 titulo-paso">CSV Exclusiones (Obligatorio)</div>
			</div>
			<div class="row">
				<div class="col-12 text-right">
					<b-button id="seguir" variant="success" v-on:click="seguir" :disabled="!disabled">SEGUIR</b-button>
					<hr />
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<label class="control-label">Seleccione año y mes</label>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
					<b-select id="anio" size="sm" :options="anios" v-model="anio" @change="seleccionaPeriodo">
						<template #first>
							<b-form-select-option :value="null">Año</b-form-select-option>
						</template>
					</b-select>
				</div>
				<div class="col-3">
					<b-select id="mes" size="sm" :options="meses" v-model="mes" @change="seleccionaPeriodo">
						<template #first>
							<b-form-select-option :value="null">Mes</b-form-select-option>
						</template>
					</b-select>
				</div>
			</div>
			<p></p>
			<div v-if="anio != null && mes != null" class="row">
				<div class="col-10">
					<label class="control-label">A continuación: sube el archivo con la planilla completa</label>
					<upload-excel type="csv" :on-success="onSuccess" :before-upload="beforeUpload" />
				</div>
			</div>
			<p></p>
			<div v-if="error" class="row">
				<div class="col-12 text-center">
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-12">
							<h5><i class="fas fa-exclamation fa-fw" /> {{ mensaje }}</h5>
						</div>
					</div>
				</div>
			</div>
			<div v-if="validacion" class="row">
				<div class="col-12">
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-5">
							<b-input id="busquedas" size="sm" placeholder="Filtro..." v-model="filtro" />
						</div>
						<div v-if="filtro != ''" class="col-3 total-filtro">{{ totalFiltrados }} registros seleccionados</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-8">
							<b-table striped small :fields="campos" :items="getProyectos" :per-page="perPage" :current-page="currentPage" head-variant="light"></b-table>
							<b-pagination v-model="currentPage" :total-rows="totalFiltrados" :per-page="perPage" size="sm" align="right"></b-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import $ from "jquery"
	import UploadExcel from "./upload_excel.vue"


	export default 
	{
		name: "Paso1",
		components: { UploadExcel },
		props: {
			confirmacion: false,
			onPeriodo: Function, // Funcion callback para informar el periodo seleccionado
			onAvanzar: Function, // Funcion callback para la accion de avanzar en el wizard
			onArchivo: Function, // Funcion callback para informar sobre el archivo cargado
		},
		data() {
			return {
				nombre: "exclusiones", // Tipo de archivo a cargar
				periodo: "",
				anio: null,
				mes: null,
				anios: [],
				meses: [ 
					{ value: "01", text: "Enero" }, 
					{ value: "02", text: "Febrero" },
					{ value: "03", text: "Marzo" },
					{ value: "04", text: "Abril" },
					{ value: "05", text: "Mayo" },
					{ value: "06", text: "Junio" },
					{ value: "07", text: "Julio" },
					{ value: "08", text: "Agosto" },
					{ value: "09", text: "Septiembre" },
					{ value: "10", text: "Octubre" },
					{ value: "11", text: "Noviembre" },
					{ value: "12", text: "Diciembre" } 
				],
				disabled: false, // Flag que controla cuando activar el boton SEGUIR
				validacion: false,
				formato: [ "client_id", "role", "name", "email", "tax_code", "address", "city", "post_code", "county", "country", "created_at", "updated_at", "payment_methods_count", "payer_id", "notes", "invitation_code", "payment_terms", "charge_code_format", "charge_code_required", "deliver_invoice_email", "starred", "billing_period", "payments_phone", "business_phone", "disable_billing", "sales_rep_id", "start_service_date", "skip_invoicing", "farmer_rep_id", "start_farming_date", "size", "sector", "payment_type", "audited_at", "invoice_emails", "using_labels" ],
				filtro: "",
				campos: [ { key: "client_id", label: "ID" }, { key: "role", label: "ROLE" } ],
				proyectos: [],
				perPage: 5,
				currentPage: 1,
				error: false, // Flag que controla cuando mostrar el mensaje de error
				mensaje: "",
			}
		},
		created() {

			// Rutina que llena la lista de anios disponibles para seleccionar
			// Desde el año actual, avanza 5 años hacia el futuro
			const now = new Date()
			var anio = now.getFullYear() - 1
			for (var a = anio; a <= anio + 5; a++)
				this.anios.push({ value: a, text: a })
		},
		computed: {

			// Retorna la lista de proyectos luego de aplicar el filtro ingresao (o si esta en blanco)
			getProyectos() {

				return this.filtrar()
			},

			// Cuenta la cantidad de proyectos a mostrar (considera el filtro)
			totalFiltrados() {

				return this.filtrar().length
			},
		},
		methods: {

			// Para seleccionar el año y el mes
			seleccionaPeriodo() {

				this.anio = $("#anio").val() != "" ? $("#anio").val() : null
				this.mes = $("#mes").val() != "" ? $("#mes").val() : null

				// Si se eligio mes y año, cambiamos validacion a TRUE para mostrar la opcion para subir el archivo
				if (this.anio != null && this.mes != null)
				{
					this.periodo = this.anio + "-" + this.mes

					if (this.onPeriodo)
						this.onPeriodo(this.periodo)
				}
			},

			// Se ejecuta antes de comenzar a leer el archivo
			// Sirve para activar el icono de espera
			beforeUpload() {

				this.error = false

				// Activamos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				return true
			},

			// Se ejecuta una vez que se leyo todo el archivo
			// Desactiva el icono de espera y valida el formato del archivo cargado
			// Envia los datos al servidor
			onSuccess(header, data, file) {

				// Ocultamos la imagen cargando
				window.event.$emit("mostrar-cargando", false)

				if (header.join() == this.formato.join()) {

					this.validacion = true
					this.proyectos = data // Asignamos los registros del archivo en el arreglo proyectos para mostrarlos en la tabla
					this.procesar()
					
					// Llamamos a la funcion callback para enviar la info del archivo cargado
					if (this.onArchivo)
						this.onArchivo({ archivo: this.nombre, nombre: file.name, tipo: file.type, tamanio: file.size, registros: data.length, avance: 0 })

				} else {

					this.mensaje = "El formato del archivo no corresponde"
					this.error = true
					this.validacion = false 
				}
			},

			// Aplica el filtro ingresado sobre los proyectos y retorna aquellos que cumplen la condicion
			// Solo se consideran los campos CLIENTE_ID y ROLE
			filtrar() {

				return this.proyectos.filter((proyecto) => {
					return proyecto.client_id.toString().toLowerCase().includes(this.filtro.toLowerCase()) || 
						proyecto.role.toString().toLowerCase().includes(this.filtro.toLowerCase())
				})
			},

			// Enviamos la info al servidor a traves de la API
			// Si el envio es existoso, activa el boton SEGUIR
			// TODO: que hacer cuando el envio devuelva error
			procesar() {

				//Guardamos los datos del proyecto en un arreglo para enviarlo al Servidor (sólo los campos CLIENT_ID y ROLE
				var data = []
				for (var proyecto of this.proyectos)
					data.push({ client_id: proyecto.client_id, role: proyecto.role })

				// Estructura con la info que se enviara al servidor
				var request = {
					"usuario": this.$usuario, 
					"destino": this.$env,
					"tx": "F0",
					"proceso": "upDataFac",
					"archivo": this.nombre, 
					"periodo": this.periodo,
					"data": data
				}	

				// Llamamos a la API
				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					if (response.data.estatus == "OK")
						this.disabled = true // Activamos el boton SEGUIR
					else {

						this.mensaje = response.data.estatus
						this.error = true
					}
					
				}).catch(ex => {

					// Si hubo un error, pasamos por aca
					console.log(ex.message)
				})
			},

			// Informa al padre (main.vue) que debe avanzar al siguiente paso, llamando a la funcion de callback
			seguir() {

				if (this.onAvanzar)
					this.onAvanzar()
			}

		}
	}

</script>
<style scoped>

	.total-filtro {
		padding-top: 3px;
		font-size: 14px;
	}

</style>
